import React from 'react';
import pluralize from 'pluralize';

import type { Timeline } from '../../types/timeline';

const TimelineStats: React.FC<{ timeline: Timeline }> = ({ timeline }) => {
  const totalViews = timeline.stats.total_views || 0;
  const totalReactions = timeline.stats.total_reactions || 0;
  const totalComments = timeline.stats.total_comments || 0;

  return (
    <div className="timeline-stats wa-grid wa-gap-s" style={{ '--min-column-size': '16ch' } as React.CSSProperties}>
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="timeline-stat-value">{totalViews}</h2>
          <span className="timeline-stat-label">{pluralize('View', totalViews)}</span>
        </div>
      </wa-card>
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="timeline-stat-value">{totalReactions}</h2>
          <span className="timeline-stat-label">{pluralize('Reaction', totalReactions)}</span>
        </div>
      </wa-card>
      <wa-card>
        <div className="wa-stack wa-gap-2xs">
          <h2 className="timeline-stat-value">{totalComments}</h2>
          <span className="timeline-stat-label">{pluralize('Comment', totalComments)}</span>
        </div>
      </wa-card>
    </div>
  );
}

export default TimelineStats;
